/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */
import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {DungeonQuestSymbols} from "./DungeonQuestGameConfig";


export class DungeonQuestGameAssets {
    //INTRO JPEG
    static INTRO_BACKGROUND:string = "intro_background";
    //INTRO
    static INTRO_LOGO:string = "introLogo";
    static INTRO_LOGO_MASK:string = "introLogoMask";
    static INTRO_LOGO_SHINE:string = "logoShine";
    static INTRO_LOGO_SPARK:string = "logoSparkAnim";

    //MAIN JPEG
    static NEAR_WIN_REEL_HIGHLIGHT:string = "background/attentionFx";
    static REAL_AREA_RANDOM_WILD_BACKGROUND:string = "background/colossal_portrait_background";
    static RANDOM_WILD_INTRO_COMET_MASK:string = "background/cometMask";
    static REAL_AREA_FREESPIN_BACKGROUND:string = "background/freespin_portrait_background";
    static REAL_AREA_FREESPIN_BACKGROUND_OVERLAY:string = "background/freespin_portrait_background_tint";
    static MAIN_GAME_LANDSCAPE:string = "background/main_landscape_background";
    static REAL_AREA_BACKGROUND:string = "background/main_portrait_background";
    static REAL_AREA_BACKGROUND_OVERLAY:string = "background/main_portrait_background_tint";

    public static getTransformIntroPlateName(symbol:string) {
        return `transform/${symbol}_transformIntro_plate`
    }


    //MAIN
    static REAL_AREA_SPIN_GLOW:string = "spinGlow";
    static REAL_AREA_SPIN_GLOW_MASK:string = "spinGlowMask";


    static RANDOM_WILD_INTRO_COMET:string = "randomComet";
    static RANDOM_WILD_INTRO_FIRE:string = "randomFire";


    static RANDOM_WILD_COLOSSAL_STILL:string = "colossalW";
    static RANDOM_WILD_CRACK_GLOW:string = "crackGlow";
    static RANDOM_WILD_EXPLOSION:string = "wildExplosion";
    static RANDOM_WILD_EXPLOSION_SMOKE:string = "wildExplosionSmoke";
    static RANDOM_WILD_SEPARATION_GLOW:string = "wildGlow";
    static RANDOM_WILD_SEPARATION:string = "wildSeparation";
    static RANDOM_WILD_LANDING_SMOKE:string = "wildLandingSmoke";

    static FS_DIVIDER:string = "fsDivider";
    static BG_DIVIDER:string = "div";
    static BG_DIVIDER_GLOW:string = "div-gradient";

    static NEAR_WIN_DIVIDER_SWOOSH:string = "nearWinDivSwoosh";
    static NEAR_WIN_DIVIDER_SIDE:string = "nearWinDivSide";
    static NEAR_WIN_DIVIDER:string = "nearWinDiv";


    static TOP_LOGO_SMALL:string = "topLogoSmall";
    static WILD_SYMBOL_TRANSFORM:string = "wildSymbolTransform";
    static WILD_STICKY_SYMBOL_TRANSFORM:string = "stickyWildSymbolTransform";
    static WILD_STICKY_SYMBOL_IDLE:string = "stickyWildSymbolIdle";

    static BIG_WIN_BIG_WIN_TEXT:string = "big";
    static BIG_WIN_MEGA_WIN_TEXT:string = "mega";
    static BIG_WIN_SUPER_MEGA_WIN_TEXT:string = "superMega";
    static BIG_WIN_FLARE:string = "bwbg";
    static BIG_WIN_PLATE_PARTICLES:string = "bwParticle";


    static FS_IDLE_PARTICLE_1:string = "freespinParticle1";
    static FS_IDLE_PARTICLE_2:string = "freespinParticle2";
    static FS_IDLE_PARTICLE_3:string = "freespinParticle3";

    static MAIN_IDLE_PARTICLE_1:string = "mainIdle1";
    static MAIN_IDLE_PARTICLE_2:string = "mainIdle2";
    static MAIN_IDLE_PARTICLE_3:string = "mainIdle3";

    static ROCK_PARTICLE_1:string = "rock1";
    static ROCK_PARTICLE_2:string = "rock2";
    static ROCK_PARTICLE_3:string = "rock3";

    static BW_PARTICLE_1:string = "coin1";
    static BW_PARTICLE_2:string = "coin2";
    static BW_PARTICLE_3:string = "coin3";
    static BW_PARTICLE_4:string = "coin4";

    static FREE_SPIN_INTRO_BASE:string = "free_spin_intro_base";
    static FREE_SPIN_INTRO_LIGHTNING:string = "free_spin_intro_lightning";
    static FREE_SPIN_INTRO_SMOKE:string = "free_spin_intro_smoke";


    static SYMBOL_WIN_END_PARTICLES:string = "symbolEndParticles";
    static SYMBOL_WIN_PARTICLES:string = "symbolWinParticles";
    static SYMBOL_WIN_PARTICLES_GLOW:string = "symbolWinParticlesGlow";

    static TRANSFORM_INTRO_SYMBOL_EXPLOSION:string = "transformExplosion";
    static TRANSFORM_INTRO_SYMBOL_LIGHTNING:string = "transformLightning";
    static TRANSFORM_INTRO_SPEED_LINES:string = "transformSpeedLines";
    static TRANSFORM_INTRO_RING:string = "transformWave";

    static SCATTER_LOOP:string = "scatterAttention";
    static SCATTER_TWO_ATTENTION:string = "scatterWin";
    static SCATTER_TWO_ATTENTION_FRAME:string = "s_win_00023";

    public static getTransformIntroGfxName(symbol:string) {
        return `${symbol}_transformIntro`
    }


    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if(stateName == null || stateName == "") {
            return symbolName;
        }
        return symbolName + "_" + stateName;
    }

    public static getSymbolStateTextures(symbolName:string, stateName:string | null = null):PIXI.Texture[] {
        if(symbolName == DungeonQuestSymbols.NONE) {
            return [PIXI.Texture.EMPTY];
        }
        return GameResources.getTextures(DungeonQuestGameAssets.getSymbolStateTexturePath(symbolName, stateName));
    }


    public static SHOCK_WAVE_RING:string = "shockwave";


    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [
            {
                name : "intro",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("intro0", "sheets/intro/intro0.json")
                ],
                animations : {
                    [DungeonQuestGameAssets.INTRO_LOGO_SPARK] : "logoStar/logoshine_00"
                }
            },
            {
                name : "introJpeg",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("introJpeg0", "sheets/introJpeg/introJpeg0.json")
                ]
            },
            {
                name : "fonts",
                assets : [
                    new BitmapFontAsset("numbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset("fifthCountUp", "fonts/bitmapfonts/fifthCountUp.fnt"),
                    new BitmapFontAsset("fifthCountUpWhite", "fonts/bitmapfonts/fifthCountUpWhite.fnt")
                ]
            }
        ],
        main : [
            {
                name : "main",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("blue0", "sheets/colorMain/blue0.json"),

                    new TextureAsset("gray0", "sheets/colorMain/gray0.json"),
                    new TextureAsset("gray1", "sheets/colorMain/gray1.json"),
                    new TextureAsset("gray2", "sheets/colorMain/gray2.json"),
                    new TextureAsset("gray3", "sheets/colorMain/gray3.json"),
                    new TextureAsset("gray4", "sheets/colorMain/gray4.json"),
                    new TextureAsset("gray5", "sheets/colorMain/gray5.json"),
                    new TextureAsset("gray6", "sheets/colorMain/gray6.json"),
                    new TextureAsset("gray7", "sheets/colorMain/gray7.json"),
                    new TextureAsset("gray8", "sheets/colorMain/gray8.json"),
                    new TextureAsset("gray9", "sheets/colorMain/gray9.json"),
                    new TextureAsset("gray10", "sheets/colorMain/gray10.json"),
                    new TextureAsset("gray11", "sheets/colorMain/gray11.json"),


                    new TextureAsset("green0", "sheets/colorMain/green0.json"),

                    new TextureAsset("purple0", "sheets/colorMain/purple0.json"),
                    new TextureAsset("purple1", "sheets/colorMain/purple1.json"),
                    new TextureAsset("purple2", "sheets/colorMain/purple2.json"),
                    new TextureAsset("purple3", "sheets/colorMain/purple3.json"),

                    new TextureAsset("red0", "sheets/colorMain/red0.json"),

                    new TextureAsset("yellow0", "sheets/colorMain/yellow0.json"),
                    new TextureAsset("yellow1", "sheets/colorMain/yellow1.json"),

                ],
                animations : {
                    [DungeonQuestGameAssets.RANDOM_WILD_LANDING_SMOKE] : "colossal_smoke_00",
                    [DungeonQuestGameAssets.RANDOM_WILD_CRACK_GLOW] : "crack_00",
                    [DungeonQuestGameAssets.RANDOM_WILD_EXPLOSION] : "w-explosion_00",
                    [DungeonQuestGameAssets.RANDOM_WILD_EXPLOSION_SMOKE] : "explsmoke_00",
                    [DungeonQuestGameAssets.RANDOM_WILD_SEPARATION_GLOW] : "wild-glow_00",
                    [DungeonQuestGameAssets.RANDOM_WILD_SEPARATION] : "colossal_00",

                    [DungeonQuestGameAssets.RANDOM_WILD_INTRO_COMET] : "comet_00",
                    [DungeonQuestGameAssets.RANDOM_WILD_INTRO_FIRE] : "fireOverlay_00",

                    [DungeonQuestGameAssets.TRANSFORM_INTRO_SYMBOL_LIGHTNING] : "transformlightning_00",
                    [DungeonQuestGameAssets.TRANSFORM_INTRO_SYMBOL_EXPLOSION] : "transformexplosion_00",
                    [DungeonQuestGameAssets.TRANSFORM_INTRO_SPEED_LINES] : "speedlines_00",

                    [DungeonQuestGameAssets.NEAR_WIN_DIVIDER] : "reeldiv_00",
                    [DungeonQuestGameAssets.NEAR_WIN_DIVIDER_SIDE] : "reeldiv2_00",
                    [DungeonQuestGameAssets.NEAR_WIN_DIVIDER_SWOOSH] : "swoosh_00",

                    [DungeonQuestGameAssets.SYMBOL_WIN_END_PARTICLES] : "win-particles_00",
                    [DungeonQuestGameAssets.SYMBOL_WIN_PARTICLES] : "symwinparticles_00",
                    [DungeonQuestGameAssets.SYMBOL_WIN_PARTICLES_GLOW] : "symwinparticles-glow_00",
                    [DungeonQuestGameAssets.WILD_SYMBOL_TRANSFORM] : "wildAttention_0",
                    [DungeonQuestGameAssets.WILD_STICKY_SYMBOL_TRANSFORM] : "stickyAttention_00",
                    [DungeonQuestGameAssets.WILD_STICKY_SYMBOL_IDLE] : "stickyIdle_00",

                    [DungeonQuestGameAssets.SCATTER_LOOP] : "s_attention_00",
                    [DungeonQuestGameAssets.SCATTER_TWO_ATTENTION] : "s_win_00",

                    [DungeonQuestGameAssets.FREE_SPIN_INTRO_BASE] : "fsIntroFxBase_00",
                    [DungeonQuestGameAssets.FREE_SPIN_INTRO_LIGHTNING] : "fsIntroFxLightning_00",
                    [DungeonQuestGameAssets.FREE_SPIN_INTRO_SMOKE] : "fsIntroFxSmoke_00",

                }
            },
            {
                name : "mainJpeg",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json")
                ]
            }
        ],

    };

    static getNearWinDividerTextures(index:number):PIXI.Texture[] {
        return GameResources.getTextures(DungeonQuestGameAssets.NEAR_WIN_DIVIDER);
    }
}
